import { css } from '@emotion/react'
import { Modal } from '@/components/atoms/Modal'
import { Button, colors, font } from 'plume-ui'
import React from 'react'
import { SourcingAnnotationCandidate } from '../reducers/sourcingAnnotationCandidates'

type Candidate = SourcingAnnotationCandidate

type Props = {
  isHidden: boolean
  modalId: string
  modalName: string
  candidate: Candidate | null
  setDelete: React.Dispatch<React.SetStateAction<Candidate | null>>
  onDelete: (id: number) => void
  onCancel: () => void
}

export const SourcingAnnotationCandidateDeleteConfirmModal: React.FC<Props> = (
  props: Props
) => {
  const handleDelete = () => {
    if (props.candidate === null) return
    props.onDelete(props.candidate.id)
  }

  const handleCancel = () => {
    props.onCancel()
  }

  const description =
    props.modalName === 'マイラベル' ? (
      <>
        全ての企業から「{props.candidate?.name}」の{props.modalName}
        が削除されます。
        <br />
        この操作は元に戻せません。
      </>
    ) : (
      <>
        「{props.candidate?.name}
        」を設定している企業の{props.modalName}
        が未選択になります。
        <br />
        この操作は元に戻せません。
      </>
    )

  return (
    <Modal
      isHidden={props.isHidden}
      zIndex={104}
      onClose={() => {
        props.setDelete(null)
      }}
    >
      <div
        data-test-id={`${props.modalId}-delete-confirm-modal`}
        css={css`
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 170px;
          max-width: 522px;
        `}
      >
        <div
          css={css`
            font-weight: ${font.weight.bold};
            font-size: 16px;
            line-height: 150%;
            letter-spacing: 0.02em;
            margin: 0 12px 0 0;
            word-break: break-all;
          `}
          data-test-id={'delete-confirm-modal-title'}
        >
          「{props.candidate?.name}」を削除しますか？
        </div>
        <div
          css={css`
            font-weight: ${font.weight.normal};
            font-size: 14px;
            line-height: 175%;
            letter-spacing: 0.02em;
            word-break: break-all;
          `}
          data-test-id={'delete-confirm-modal-description'}
        >
          {description}
        </div>
        <div
          css={css`
            display: flex;
            justify-content: flex-end;
          `}
        >
          <div
            css={css`
              padding: 4px;
            `}
          >
            <Button
              className="cancel"
              color="white"
              css={css`
                width: 96px;
                height: 40px;
                font-weight: ${font.weight.normal};
                font-size: 14px;
                line-height: 100%;
                &.pl-button {
                  padding: 0px;
                }
              `}
              onClick={handleCancel}
            >
              キャンセル
            </Button>
          </div>
          <div
            css={css`
              padding: 4px;
            `}
          >
            <Button
              data-test-id={`confirm-delete-${props.modalId}`}
              className="delete"
              css={css`
                background: ${colors.red60};
                border: 0px;
                width: 112px;
                height: 40px;
                &:hover {
                  background: ${colors.red70};
                }
              `}
              onClick={handleDelete}
            >
              削除
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
